<script setup lang="ts">
    defineOptions({
        name: 'DefaultLayout'
    });
</script>
<template>
    <div class="h-screen w-full flex flex-col overflow-hidden">
        <RouterView />
    </div>
</template>
